<div class="addon-remove-dialog" fxLayout="column">
  <div class="dialog-header">
    <h2 class="dialog-title" id="addon-remove-dialog-title">
      {{ 'billing.addonRemoveDialogTitle' | translate:{ addonName: data.addonTitle } }}
    </h2>
  </div>

  <div class="churn-reason-section">
    <p class="churn-section-heading" id="addon-remove-churn-heading">
      {{ 'billing.addonRemoveChurnSectionTitle' | translate }}
    </p>
    <mat-radio-group class="churn-reason-group" color="primary" [(ngModel)]="selectedChurnReason"
      aria-labelledby="addon-remove-churn-heading">
      <mat-radio-button *ngFor="let reason of churnReasons" [value]="reason.value" class="churn-reason-option">
        {{ reason.labelKey | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="info-callout" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <img class="info-callout-icon" src="assets/images/billing/addons/removal-info-icon.svg" aria-hidden="true" alt="">
    <p class="info-callout-text">{{ 'billing.addonRemainsActiveText' | translate }}</p>
  </div>

  <div class="dialog-footer">
    <div class="footer-actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
      <button mat-stroked-button type="button" class="btn-keep" (click)="onKeep()">
        {{ 'billing.addonRemoveKeepCta' | translate | uppercase }}
      </button>
      <span class="remove-btn-tooltip-host" [matTooltip]="'billing.addonRemoveSelectReasonHint' | translate"
        [matTooltipDisabled]="!!selectedChurnReason" matTooltipPosition="below" [matTooltipShowDelay]="0">
        <button mat-raised-button type="button" color="primary" class="btn-remove" (click)="onRemove()"
          [disabled]="!selectedChurnReason">
          {{ 'billing.addonRemoveRemoveAnywayCta' | translate | uppercase }}
        </button>
      </span>
    </div>
  </div>
</div>
